import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { TemplateSource, TemplateType } from 'constants/templateTypes';
import { CampaignType } from 'modules/domains/campaign';
import { SelectedMessageMedium, TemplateMetadata } from 'modules/templateEditor/common/types';
import { TemplatePicker } from 'modules/templatePicker';
import { Spinner } from 'ui/spinner';
import { spacing } from 'ui/theme';

import { ATTACH_TEMPLATE_TAKEOVER_ID } from './AttachTemplateTakeover.constant';
import { TemplatePickerHeader } from './TemplatePickerHeader';

const TakeoverBodyContainer = styled.section`
  padding: 0 ${spacing.double};
  height: 100%;

  > :first-child {
    padding-bottom: ${spacing.plusHalf};
  }
`;

type AttachTemplateTakeoverBodyProps = {
  showLoading: boolean;
  selectedTab: TemplateSource;
  filter: string;
  setSelectedTab: Dispatch<SetStateAction<TemplateSource>>;
  showWorkflow: boolean;
  search: string;
  setSearch: (value: string) => void;
  messageMedium: SelectedMessageMedium;
  setSelectedDataFeed: (dataFeedId: number | null) => void;
  selectedTemplate: TemplateMetadata | null;
  setSelectedTemplate: (template: TemplateMetadata) => void;
  templateId?: number;
  placementId?: number;
  useDataFeeds: boolean;
  templateType: TemplateType[];
  setTemplateType: Dispatch<SetStateAction<TemplateType[]>>;
  campaignType: CampaignType;
};

export const AttachTemplateTakeoverBody = ({
  showLoading,
  selectedTab,
  setSelectedTab,
  showWorkflow,
  search,
  setSearch,
  filter,
  messageMedium,
  setSelectedDataFeed,
  selectedTemplate,
  setSelectedTemplate,
  templateId,
  placementId,
  useDataFeeds,
  templateType,
  setTemplateType,
  campaignType,
}: AttachTemplateTakeoverBodyProps) => {
  return (
    <TakeoverBodyContainer data-test={ATTACH_TEMPLATE_TAKEOVER_ID}>
      {showLoading ? (
        <Spinner />
      ) : (
        <>
          <TemplatePickerHeader
            selectedTemplate={selectedTemplate}
            selectedTab={selectedTab}
            search={search}
            setSearch={setSearch}
            showWorkflow={showWorkflow}
            setSelectedTab={setSelectedTab}
            campaignType={campaignType}
            messageMedium={messageMedium}
            templateType={templateType}
            setTemplateType={setTemplateType}
          />

          <TemplatePicker
            campaignType={campaignType}
            forceRefresh
            filter={filter}
            messageMedium={messageMedium as any}
            onSelectDataFeed={setSelectedDataFeed as any}
            onSelectTemplate={setSelectedTemplate as any}
            placementId={placementId}
            templateId={templateId}
            templateTypeFilter={templateType}
            selectedTab={selectedTab}
            useDataFeeds={useDataFeeds}
          />
        </>
      )}
    </TakeoverBodyContainer>
  );
};
